export default "__VITE_ASSET__CbZW9ZGG__"